module.exports = __webpack_public_path__ + "static/media/bonkoshop.00b8bb32.png";